<template>
  <!-- 火车时刻 -->
  <div>
    <div class="comInfo">
      <!-- 中间 -->
      <div class="rowB">
        <div class="body">
          <div class="topTitle">{{info.title}}</div>
          <!-- <div class="littleTitle">
            <span>发布日期：{{info.createDate}}</span>
            <span style="margin-left:5px">编辑者：admin</span>
            <span style="margin-left:5px">来源：{{info.source}}</span>
            <span style="margin-left:5px">点击数：{{info.hits}}</span>
          </div> -->
          <div class="line"></div>
          <div class="leftBody">
            <div v-html="info.details" class="leftBodyFont">
               {{ info.details }}
             </div>
          </div>
        </div>
      </div>

      <!-- 右边 -->
      <div class="rowC">
        <div class="layout">
          <div style="writing-mode:vertical-rl;display:flex;flex-direction:row">
            <div style="margin-top:1.018vh;">武夷山景区</div>
            <div style="margin-top:1.018vh;">天下难寻</div>
            <div style="margin-top:1.018vh;">Wuyi</div>
            <div>Mountain</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/css/details.css";
import { getBottomList } from "@/api/common";
export default {
  name: "Company",
  data() {
    return {
     info:{} 
    };
  },
  mounted(){
    this.getInfoFunction()
  },
  methods: {
    //获取
    async getInfoFunction () {
      const { code, data } = await getBottomList();
      if (code == 200) {
        if (data.length > 0 && data[1]!=undefined) {
          this.info = data[1]
          // this.getHitsFunction(this.info.id)
        }
      }
    }, 
    //点击
    async getHitsFunction(id) {
      const { code, data } = await gettTrafficTrainHits(id);
    },
  }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/footer/contactUs.vue